export default {
    parts: ['container', 'list', 'listItem', 'listItemSx', 'heading'],
    baseStyle: {
        containerLinks: {
            color: 'text.inverse',
        },
        list: {
            display: 'flex',
            gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
            alignItems: 'flex-start',
            textStyle: ['body-medium'],
            fontWeight: 'regular',
        },
        heading: {
            textStyle: 'body-small',
            color: 'foreground.neutral.inverse',
            fontWeight: 'medium',
            paddingY: {
                base: 'xxxsmall.base',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
                xl: 'xxxsmall.xl',
            },
            marginBottom: {
                base: 'xxsmall.base',
                md: 'xxsmall.md',
                lg: 'xxsmall.lg',
                xl: 'xxsmall.xl',
            },
        },
        stackWrap: {
            flexWrap: 'wrap',
            justifyContent: {base: 'center', lg: 'flex-end'},
            width: '100%',
        },
    },
    variants: {
        vertical: {},
        horizontal: {
            listItem: {
                borderLeft: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                textStyle: ['body-xxsmall'],
                fontWeight: 'regular',
                //paddingLeft: '0.5rem',
                paddingLeft: 'xsmall.base',
            },
            listItemSx: {
                '&:first-of-type': {
                    borderLeft: 0,
                    paddingLeft: 0,
                    marginLeft: 0,
                    paddingRight: 0,
                },
            },
            list: {
                gap: 'xsmall.base',
            },
        },
    },
    defaultProps: {
        variant: 'vertical',
    },
}
